import {
  reactive, getCurrentInstance, watch, toRefs,
} from '@vue/composition-api'
import router from '@/router'
// eslint-disable-next-line object-curly-newline

export const isObject = obj => typeof obj === 'object' && obj !== null && !Array.isArray(obj)

export const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)]

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const isDynamicRouteActive = route => {
  const { route: resolvedRoute } = router.resolve(route)
  return resolvedRoute.path === router.currentRoute.path
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy
  const state = reactive({
    route: vm.$route,
  })

  watch(
    () => vm.$route,
    r => {
      state.route = r
    },
  )

  return { ...toRefs(state), router: vm.$router }
}

export const debounce = (func, timeout) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => func(...args), timeout)
  }
}
export const onlyWithValue = object => {
  const newObject = {}
  Object.entries(object).forEach(([key, value]) => {
    if (isObject(value)) {
      const data = onlyWithValue(value)
      if (Object.keys(data).length) {
        newObject[key] = data
      }
    } else if (value !== null && value !== '') {
      newObject[key] = value
    }
  })
  return newObject
}

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param data
 * @param formData
 * @param parentKey
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }

export function jsonToFormData(data, formData = new FormData(), parentKey) {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in data) {
    // eslint-disable-next-line no-prototype-builtins
    if (data.hasOwnProperty(key)) {
      const fullKey = parentKey ? `${parentKey}[${key}]` : key

      if (data[key] instanceof Blob) {
        formData.append(fullKey, data[key], data[key].name || 'file')
      } else if (isObject(data[key])) {
        if (Array.isArray(data[key])) {
          for (let i = 0; i < data[key].length; i++) {
            jsonToFormData({ [i]: data[key][i] }, formData, fullKey)
          }
        } else {
          jsonToFormData(data[key], formData, fullKey)
        }
      } else if (data[key] == null) {
        formData.append(fullKey, '')
      } else {
        formData.append(fullKey, data[key])
      }
    }
  }

  return formData
}
